import { DocumentReference, FieldValue, Timestamp } from "firebase/firestore"
import { Template } from "./templates"

// OpenAI ChatCompletionRequestMessageと同じ
export type ChatMessage = {
  role: string,
  content: string,
  name?: string,
  function_call?: object,
}

export type ChatMessageChoice = {
  index: number,
  message: ChatMessage,
}

// ユーザープロンプトを送信するためのリクエスト
// export type ChatMessageRequest = {
//   is_public?: boolean, // 公開するかどうか
//   doc_id?: string, // docId
//   uid?: string, // uid
//   display_name?: string, // ユーザー名
//   email?: string, // 投稿者のメールアドレス
//   chat_session_id?: string, // undefinedの時新規ChatSession作成
//   model: string, // Model name of a bot name
//   messages: ChatMessage[], // context for a next message
//   function_call?: string, // 関数呼び出し auto or none
//   functions?: object, // 関数定義
//   created?: FieldValue | Timestamp,
// }

// ユーザープロンプトを送信するためのリクエスト
export type ChatMessageRequest = {
  // eslint-disable-next-line camelcase
  is_public?: boolean, // 公開するかどうか
  doc_id?: string, // eslint-disable-line camelcase
  uid?: string, // uid
  display_name?: string, // eslint-disable-line camelcase
  email?: string, // 投稿者のメールアドレス
  chat_session_id?: string, // eslint-disable-line camelcase
  model: string, // Model name of a bot name
  messages: ChatMessage[], // context for a next message
  template?: DocumentReference<Template>, // 利用したテンプレート
  // function_call?: string, // 関数呼び出し auto or none
  // functions?: object, // 関数定義
  created?: FieldValue | Timestamp,
  modified?: FieldValue | Timestamp,
}


// ChatMessageRequestの型ガード
export const isChatMessageRequest = (data: any): data is ChatMessageRequest => {
  return data.model !== undefined && data.messages !== undefined;
}


// ユーザープロンプトに対するLLMからのレスポンス
export type ChatMessageResponse = {
  doc_id?: string, // docId
  chat_session_id?: string, // undefinedの時新規ChatSession作成
  chat_message_request?: DocumentReference, // 対応するリクエスト // eslint-disable-line camelcase
  id: string, // LLMのid
  object: string, // LLMのobject
  choices: ChatMessageChoice[],
  created_in_api: FieldValue | Timestamp,
  created: FieldValue | Timestamp,
  usage: LLMUsage, // LLMの使用量
  model: string | undefined,
  last_messages?: ChatMessage[], // context for a next message
}

// ChatMessageRequestの型ガード
export const isChatMessageResponse = (data: any): data is ChatMessageResponse => {
  return data.choices !== undefined && data.usage !== undefined;
}

// 一連のやり取りを表すための型
export type ChatMessageBlock = ChatMessageRequest | ChatMessageResponse;

export const isChatMessageBlock = (data: any): data is ChatMessageBlock => {
  return isChatMessageRequest(data) || isChatMessageResponse(data);
}

export type ChatSession = {
  id?: string,
  title: string,
  created: FieldValue | Timestamp, // 生成日時
  modified: FieldValue | Timestamp,
}

// ChatSummariesの中に格納されるChatSummary
// 見出しとchat_sessionへのリンクを格納する
export interface ChatSessionSummary {
  chat_session: DocumentReference,
  title: string,
  embedding?: number[],
  created: FieldValue | Timestamp,
  modified: FieldValue | Timestamp,
}

// ChatSessionSummaryの型ガード
// 対象データとの類似度の距離を追加した型
export interface ChatSessionsSummaryWithDistance extends ChatSessionSummary {
  distance?: number,
}

// ChatSessionの一覧を格納するドキュメント
// 1MBを超える場合は扱いを変更する必要がある
export type ChatSummaries = {
  session_summaries: ChatSessionSummary[],
  created: FieldValue | Timestamp,
  modified: FieldValue | Timestamp,
}

// sendChatMessage関数のリクエストパラメータ
export type sendChatMessageRequest = {
  is_public: boolean, // eslint-disable-line camelcase
  chat_session_id?: string, // eslint-disable-line camelcase
  model: string,
  public_template_id?: string, // eslint-disable-line camelcase
  template_id?: string, // eslint-disable-line camelcase
  message: string,
  conversation_memory_size?: number, // eslint-disable-line camelcase
}
